<script>

    import { toast } from 'bulma-toast'
    import { fixedpriceStore, fixedpricesStore, modalStore } from '../stores'

    import FixedpricesService from '../$services/fixedprices.service.js'

    import Providers from '../$components/providers.svelte'
    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'
    import InputText from '../$components/input.text.svelte'
    import InputNumber from '../$components/input.number.svelte'
    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'
    import Select from '../$components/select.svelte'

    let loading = false
    let data = {
        provider: $fixedpriceStore.provider,
        service: $fixedpriceStore.service,
        volumetricMin: $fixedpriceStore.volumetricMin,
        volumetricMax: $fixedpriceStore.volumetricMax,
        setPrice: $fixedpriceStore.setPrice,
        percent: $fixedpriceStore.percent,
        iva: $fixedpriceStore.iva,
        weightControl: $fixedpriceStore.weightControl,
        shipmentPrice: $fixedpriceStore.shipmentPrice,
        weightCost: $fixedpriceStore.weightCost,
        coverageCost: $fixedpriceStore.coverageCost || 0,
        coverageSpecial: $fixedpriceStore.coverageSpecial || 0,
        expired: $fixedpriceStore.expired,
    }

    async function updateFixedprice() {

        loading = true
        const resp = await FixedpricesService.updateFixedprice($fixedpriceStore._id, data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        fixedpricesStore.replace(resp.data)

        toast({message: 'Precio fijo actualizado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Form on:submit={ updateFixedprice } { loading }>

    <Providers bind:provider={data.provider} bind:service={data.service} isDefault={false} />

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.volumetricMin} label="Peso mínimo" placeholder="Peso mínimo (kg)" />        
        </div>
        <div class="column">
            <InputText bind:value={data.volumetricMax} label="Peso máximo" placeholder="Peso máximo (kg)" />     
        </div>
    </div>

    <Select 
        bind:value={data.setPrice}
        label="Tipo de precio"
        options={[
            {value: 'pricing', text: 'Precio fijo'},
            {value: 'percent', text: 'Porcentaje'},
            {value: 'flat', text: 'Flat'},
        ]}
    />

    {#if data.setPrice === 'pricing'}
        <InputNumber bind:value={data.shipmentPrice} step="0.01" label="Precio de envío" placeholder="Precio de envío" />
    {/if}

    {#if data.setPrice === 'percent'}
        <div class="columns">
            <div class="column">
                <InputNumber label="Porcentaje" bind:value={data.percent} />
            </div>
            <div class="column">
                <InputNumber label="IVA" bind:value={data.iva} />
            </div>
        </div>
    {/if}

    {#if data.setPrice === 'flat'}
        <div class="columns">
            <div class="column">
                <InputNumber bind:value={data.weightControl} label="Peso referencia" placeholder="Peso referencia" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.shipmentPrice} step="0.01" label="Precio base" placeholder="Precio base" />
            </div>
            <div class="column">
                <InputNumber bind:value={data.weightCost} step="0.01" label="Costo por kilo" placeholder="Costo por kilo" />
            </div>
        </div>
    {/if}

    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.coverageCost} step="0.01" label="Cobertura costo" placeholder="Cobertura costo" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.coverageSpecial} step="0.01" label="Cobertura especial" placeholder="Cobertura especial" />
        </div>
    </div>
    
    <Date bind:value={data.expired} label="Fecha de expiración" />
    
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave text="Guardar" icon="save" { loading } />
    </div>

</Form>